// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* /user_profile/notification_settings */

.notification-settings-page {
  max-width: 100%;
  margin: 10px auto 40px;
  color: #ededed;
  padding-left: 20px;
}

body.light_theme .notification-settings-page {
  color: #0f172a;
}

.notification-settings-page__crumb {
  margin: 0 0 10px;
  font-size: 15px;
  font-weight: 500;
}

.notification-settings-page__crumb a {
  color: #64748b;
  text-decoration: none;
}

.notification-settings-page__crumb a:hover {
  text-decoration: underline;
}

.notification-settings-page__crumb-sep {
  margin: 0 6px;
  color: #94a3b8;
}

.notification-settings-page__title {
  margin: 30px 0 22px;
  font-size: 40px;
  font-weight: 600;
  letter-spacing: -0.02em;
  color: #e9e9e9;
}

.notification-settings-page__crumb {
  color: #f5f5f5;
}

body.light_theme .notification-settings-page__crumb {
  color: #171717;
}


body.light_theme .notification-settings-page__title {
  color: #0f172a;
}

.notification-settings-page__card {
  background: #ffffff0d;
  border: 1px solid #f3f4f630;
  border-radius: 10px;
  box-shadow: 0 0px 5px rgba(0, 0, 0, 0.05);
  padding: 20px;
  margin-bottom: 36px;
}

body.light_theme .notification-settings-page__card {
  background: #ffffff;
  border: 1px solid #E5E7EB;
}

.notification-settings-page__card-title {
  margin: 0 0 14px;
  font-size: 18px;
  font-weight: 600;
}

.notification-settings-page__info {
  margin: 0;
  font-size: 14px;
  line-height: 1.55;
  color: #eeeeee;
}

body.light_theme .notification-settings-page__info {
  color: #64748b;
}

.notification-settings-page__options {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.notification-settings-page__option {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 10px 4px;
  cursor: pointer;
  border-radius: 8px;
}

.notification-settings-page__option:hover {
  background: #f8fafc00;
}

body.light_theme .notification-settings-page__option:hover {
  background: #f8fafc;
}

.notification-settings-page__option input {
  margin-top: 3px;
  accent-color: #0f172a;
  flex-shrink: 0;
}

.notification-settings-page__option-body {
  font-size: 15px;
  line-height: 1.45;
  color: #eeeeee;
  font-weight: 500;
}

body.light_theme .notification-settings-page__option-body {
  color: #101828;
}

.notification-settings-page__rec {
  color: #D1AA67;
  font-weight: 500;
}

.notification-settings-page__warn-note {
  color: #94a3b8;
  font-size: 13px;
}

.notification-settings-page__warn-note--emphasis {
  color: #c2410c;
}

@media (max-width:1200px) {

  .notification-settings-page__title {
    font-size: 26px;
  }

}

@media (max-width: 767.98px) {
  .notification-settings-page__title {
    font-size: 22px;
  }

  .notification-settings-page {
    padding-left: 0px;
  }

  .notification-settings-page__card {
    margin-bottom: 20px;
  }


  .notification-settings-page__title {
    font-size: 24px;
  }

  .notification-settings-page__card .notification-settings-page__option {
    padding: 3px 0px;
  }


}

@media (max-width:580px) {

  .notification-settings-page__title {
    font-size: 20px;
  }

  .notification-settings-page__option-body {
    font-size: 13px;
  }

}`, "",{"version":3,"sources":["webpack://./src/ui/Pages/NotificationSettingsPage/NotificationSettingsPage.css"],"names":[],"mappings":"AAAA,wCAAwC;;AAExC;EACE,eAAe;EACf,sBAAsB;EACtB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;;AAGA;EACE,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,2BAA2B;EAC3B,mBAAmB;EACnB,yCAAyC;EACzC,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,iBAAiB;EACjB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;;EAEE;IACE,eAAe;EACjB;;AAEF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,mBAAmB;EACrB;;;EAGA;IACE,eAAe;EACjB;;EAEA;IACE,gBAAgB;EAClB;;;AAGF;;AAEA;;EAEE;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;AAEF","sourcesContent":["/* /user_profile/notification_settings */\n\n.notification-settings-page {\n  max-width: 100%;\n  margin: 10px auto 40px;\n  color: #ededed;\n  padding-left: 20px;\n}\n\nbody.light_theme .notification-settings-page {\n  color: #0f172a;\n}\n\n.notification-settings-page__crumb {\n  margin: 0 0 10px;\n  font-size: 15px;\n  font-weight: 500;\n}\n\n.notification-settings-page__crumb a {\n  color: #64748b;\n  text-decoration: none;\n}\n\n.notification-settings-page__crumb a:hover {\n  text-decoration: underline;\n}\n\n.notification-settings-page__crumb-sep {\n  margin: 0 6px;\n  color: #94a3b8;\n}\n\n.notification-settings-page__title {\n  margin: 30px 0 22px;\n  font-size: 40px;\n  font-weight: 600;\n  letter-spacing: -0.02em;\n  color: #e9e9e9;\n}\n\n.notification-settings-page__crumb {\n  color: #f5f5f5;\n}\n\nbody.light_theme .notification-settings-page__crumb {\n  color: #171717;\n}\n\n\nbody.light_theme .notification-settings-page__title {\n  color: #0f172a;\n}\n\n.notification-settings-page__card {\n  background: #ffffff0d;\n  border: 1px solid #f3f4f630;\n  border-radius: 10px;\n  box-shadow: 0 0px 5px rgba(0, 0, 0, 0.05);\n  padding: 20px;\n  margin-bottom: 36px;\n}\n\nbody.light_theme .notification-settings-page__card {\n  background: #ffffff;\n  border: 1px solid #E5E7EB;\n}\n\n.notification-settings-page__card-title {\n  margin: 0 0 14px;\n  font-size: 18px;\n  font-weight: 600;\n}\n\n.notification-settings-page__info {\n  margin: 0;\n  font-size: 14px;\n  line-height: 1.55;\n  color: #eeeeee;\n}\n\nbody.light_theme .notification-settings-page__info {\n  color: #64748b;\n}\n\n.notification-settings-page__options {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.notification-settings-page__option {\n  display: flex;\n  align-items: flex-start;\n  gap: 12px;\n  padding: 10px 4px;\n  cursor: pointer;\n  border-radius: 8px;\n}\n\n.notification-settings-page__option:hover {\n  background: #f8fafc00;\n}\n\nbody.light_theme .notification-settings-page__option:hover {\n  background: #f8fafc;\n}\n\n.notification-settings-page__option input {\n  margin-top: 3px;\n  accent-color: #0f172a;\n  flex-shrink: 0;\n}\n\n.notification-settings-page__option-body {\n  font-size: 15px;\n  line-height: 1.45;\n  color: #eeeeee;\n  font-weight: 500;\n}\n\nbody.light_theme .notification-settings-page__option-body {\n  color: #101828;\n}\n\n.notification-settings-page__rec {\n  color: #D1AA67;\n  font-weight: 500;\n}\n\n.notification-settings-page__warn-note {\n  color: #94a3b8;\n  font-size: 13px;\n}\n\n.notification-settings-page__warn-note--emphasis {\n  color: #c2410c;\n}\n\n@media (max-width:1200px) {\n\n  .notification-settings-page__title {\n    font-size: 26px;\n  }\n\n}\n\n@media (max-width: 767.98px) {\n  .notification-settings-page__title {\n    font-size: 22px;\n  }\n\n  .notification-settings-page {\n    padding-left: 0px;\n  }\n\n  .notification-settings-page__card {\n    margin-bottom: 20px;\n  }\n\n\n  .notification-settings-page__title {\n    font-size: 24px;\n  }\n\n  .notification-settings-page__card .notification-settings-page__option {\n    padding: 3px 0px;\n  }\n\n\n}\n\n@media (max-width:580px) {\n\n  .notification-settings-page__title {\n    font-size: 20px;\n  }\n\n  .notification-settings-page__option-body {\n    font-size: 13px;\n  }\n\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
